import { FaReact, FaNodeJs, FaJava, FaHtml5, FaJs, FaPython} from "react-icons/fa";

export const eduTechData = [
  {
    id: 1,
    title: 'Custom LMS',
    category: 'Web App Development',
    description: 'Our Custom Learning Management Systems are tailored to your specific educational needs. We create intuitive, scalable, and robust platforms that provide a seamless learning experience for your students and easy management for your administrators. From course creation and content management to tracking and reporting, we build LMS solutions that empower your educational vision.',
    image: '/img/edutech/LMS.svg',
    sub_headers: {
      title: "Custom LMS",
      sub_points: [    
        "Tailored to your specific educational needs.",
        "Intuitive, scalable, and robust platforms.",
        "Seamless learning experience for students and easy management for administrators."
      ],
      mockupImage: "/img/edutech/LMS.svg",
    },
    problem: {
      challenges: [
        "Creating a platform that is flexible enough to accommodate a variety of teaching styles and content types.",
        "Ensuring the platform is scalable to handle a growing number of users and courses.",
        "Providing a user-friendly interface for both students and administrators."
      ],
      mockupImage: "/img/edutech/LMS.svg",
    },
    solutions: {
      desc: "To address these challenges, we developed a modular and customizable LMS platform. The platform is built on a scalable architecture that can grow with your organization. We also focused on creating an intuitive and user-friendly interface to ensure a positive experience for all users.",
      points: [
        "Modular and customizable platform.",
        "Scalable architecture.",
        "User-friendly interface.",
        "Comprehensive course and content management features.",
        "Advanced tracking and reporting capabilities."
      ],
      mockupImage: "/img/edutech/LMS.svg",
    },
    process: [
        {
            id: 1,
            title: "Curriculum Analysis & Goal Setting",
            description: "We begin by analyzing your existing curriculum and content to define clear learning objectives and goals for your custom LMS."
        },
        {
            id: 2,
            title: "UX/UI Design & Prototyping",
            description: "Our team designs an intuitive, user-friendly interface and creates interactive prototypes to visualize the learner and administrator experience."
        },
        {
            id: 3,
            title: "LMS Development & SIS Integration",
            description: "We build the core LMS features and integrate with your existing Student Information System (SIS) for seamless data flow."
        },
        {
            id: 4,
            title: "Deployment, Training & Support",
            description: "We deploy the platform, provide comprehensive training to your team, and offer ongoing support to ensure a smooth rollout."
        }
    ],
    benefits: {
      desc: "Our custom LMS has empowered clients to deliver a more effective and engaging learning experience, resulting in higher adoption rates and improved student outcomes.",
      metrics: [
        {
          title: "Student Engagement",
          value: "45%",
          extra: "increase through personalized learning paths",
        },
        {
          title: "Administrative Overhead",
          value: "60%",
          extra: "reduction with automated grading and reporting",
        },
        {
          title: "Course Completion Rates",
          value: "30%",
          extra: "increase due to improved user experience",
        },
      ],
    },
    features: [
      {
        id: 1,
        title: "Course Management",
        sub_features: [
          "Create and manage courses",
          "Upload and organize content",
          "Set prerequisites and learning paths"
        ]
      },
      {
        id: 2,
        title: "User Management",
        sub_features: [
          "Enroll and manage students",
          "Assign roles and permissions",
          "Track student progress and performance"
        ]
      },
    ],
    technologies: [
      { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
      { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
      { name: "HTML5", icon: <FaHtml5 className="text-orange-500 text-3xl" /> },
      { name: "JavaScript", icon: <FaJs className="text-yellow-400 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Amazing work! The Techvelly team was patient, super fast, and delivered everything perfectly.",
            author: "iryna vezh",
            title: "United States"
        }
    ],
    faq: [
        {
            id: 1,
            question: "How long does it take to build a custom LMS?",
            answer: "The timeline for building a custom LMS can vary depending on the complexity of the project. However, we typically deliver a first version within 3-4 months."
        },
        {
            id: 2,
            question: "Can you integrate the LMS with our existing systems?",
            answer: "Yes, we can integrate the LMS with a wide range of third-party systems, including SIS, CRM, and payment gateways."
        }
    ]
  },
  {
    id: 2,
    title: 'Live Video Trainings',
    category: 'Web App Development',
    description: 'Engage your audience with our high-quality Live Video Training solutions. We provide the tools and technology to conduct real-time, interactive training sessions that are both engaging and effective. Our platforms support features like screen sharing, real-time Q&A, breakout rooms, and session recording, ensuring a dynamic and collaborative learning environment.',
    image: '/img/edutech/LVT.jpg',
    sub_headers: {
        title: "Live Video Trainings",
        sub_points: [
            "Engage your audience with high-quality, real-time, interactive training sessions.",
            "Features like screen sharing, real-time Q&A, breakout rooms, and session recording.",
            "Dynamic and collaborative learning environment."
        ],
        mockupImage: "/img/edutech/LVT.jpg",
    },
    problem: {
        challenges: [
            "Ensuring low-latency video streaming for a smooth user experience.",
            "Providing a reliable and scalable platform for a large number of concurrent users.",
            "Integrating interactive features to keep participants engaged."
        ],
        mockupImage: "/img/edutech/LVT.jpg",
    },
    solutions: {
        desc: "We built a robust live video training platform using WebRTC for real-time communication. The platform is designed to be highly scalable and reliable, with a focus on providing an interactive and engaging learning experience. Features like real-time Q&A, polls, and breakout rooms help to keep participants engaged and facilitate collaboration.",
        points: [
            "Low-latency video streaming with WebRTC.",
            "Scalable and reliable platform for large audiences.",
            "Interactive features like Q&A, polls, and breakout rooms.",
            "Session recording and playback.",
            "Custom branding and white-labeling options."
        ],
        mockupImage: "/img/edutech/LVT.jpg",
    },
    process: [
        {
            id: 1,
            title: "Infrastructure Assessment & Planning",
            description: "We assess your bandwidth and infrastructure to ensure a smooth and reliable live video training experience for all users."
        },
        {
            id: 2,
            title: "Platform Customization & Branding",
            description: "We customize the platform to match your brand and create a seamless user experience for your audience."
        },
        {
            id: 3,
            title: "Feature Integration & Testing",
            description: "We integrate interactive features like Q&A, polls, and breakout rooms, and conduct rigorous testing to ensure a bug-free platform."
        },
        {
            id: 4,
            title: "Instructor Training & Event Support",
            description: "We provide comprehensive training for your instructors and offer live event support to ensure a successful training session."
        }
    ],
    benefits: {
        desc: "Our live video training platform has enabled clients to deliver engaging and effective training to a global audience, improving training outcomes and reducing costs.",
        metrics: [
            {
                title: "Geographic Reach",
                value: "80%",
                extra: "increase in audience reach",
            },
            {
                title: "Travel Costs",
                value: "70%",
                extra: "reduction compared to in-person training",
            },
            {
                title: "Training Effectiveness",
                value: "40%",
                extra: "improvement in post-training assessments",
            },
        ],
    },
    features: [
        {
            id: 1,
            title: "Interactive Tools",
            sub_features: [
                "Real-time Q&A and polls",
                "Breakout rooms for group activities",
                "Whiteboard and screen sharing"
            ]
        },
        {
            id: 2,
            title: "Platform Features",
            sub_features: [
                "Session recording and playback",
                "Attendance tracking and reporting",
                "Custom branding and registration pages"
            ]
        },
    ],
    technologies: [
        { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
        { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
        { name: "WebRTC", icon: <FaJava className="text-red-500 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Fantastic experience! Communication was quick, updates were done instantly, and I was informed every step of the way.",
            author: "justin_b_lane",
            title: "United States"
        }
    ],
    faq: [
        {
            id: 1,
            question: "What is the maximum number of participants you can support?",
            answer: "Our platform can support up to 1000 concurrent participants in a single session."
        },
        {
            id: 2,
            question: "Can we customize the look and feel of the platform?",
            answer: "Yes, we offer custom branding and white-labeling options to match your company's branding."
        }
    ]
  },
  {
    id: 3,
    title: 'AI Integration',
    category: 'AI-Driven',
    description: 'Revolutionize your educational offerings with our AI Integration services. We leverage the power of Artificial Intelligence to create personalized learning paths, automate grading, and provide intelligent feedback to students. Our AI-driven solutions can help you deliver a more effective and engaging learning experience that adapts to the individual needs of each learner.',
    image: '/img/edutech/Ai Integration.jpg',
    sub_headers: {
        title: "AI Integration",
        sub_points: [
            "Personalized learning paths for each student.",
            "Automated grading and intelligent feedback.",
            "Adaptive learning experience."
        ],
        mockupImage: "/img/edutech/Ai Integration.jpg",
    },
    problem: {
        challenges: [
            "Developing accurate and reliable AI models for grading and feedback.",
            "Integrating AI features seamlessly into existing learning platforms.",
            "Ensuring the ethical use of AI in education."
        ],
        mockupImage: "/img/edutech/Ai Integration.jpg",
    },
    solutions: {
        desc: "We developed a suite of AI-powered tools that can be integrated into any learning platform. Our tools use machine learning and natural language processing to provide personalized learning experiences, automate grading, and provide intelligent feedback to students. We also provide guidance on the ethical implementation of AI in education.",
        points: [
            "AI-powered personalized learning paths.",
            "Automated grading and feedback.",
            "Natural language processing for analyzing student responses.",
            "Integration with existing learning platforms.",
            "Ethical AI implementation guidelines."
        ],
        mockupImage: "/img/edutech/Ai Integration.jpg",
    },
    process: [
        {
            id: 1,
            title: "AI Opportunity Analysis",
            description: "We identify and analyze opportunities to integrate AI-powered features into your existing educational offerings to enhance the learning experience."
        },
        {
            id: 2,
            title: "AI Model Development & Training",
            description: "Our team develops and trains custom AI models for features like personalized recommendations, automated grading, and intelligent feedback."
        },
        {
            id: 3,
            title: "Seamless Integration & API Development",
            description: "We seamlessly integrate the AI models into your existing platform and develop robust APIs for easy data exchange."
        },
        {
            id: 4,
            title: "Ethical AI Deployment & Monitoring",
            description: "We ensure the ethical deployment of AI, provide guidance on responsible usage, and continuously monitor model performance."
        }
    ],
    benefits: {
        desc: "Our AI integration services have helped clients create more effective and engaging learning experiences, leading to improved student outcomes and reduced instructor workload.",
        metrics: [
            {
                title: "Student Performance",
                value: "35%",
                extra: "improvement with personalized learning paths",
            },
            {
                title: "Instructor Workload",
                value: "55%",
                extra: "reduction through automated grading and feedback",
            },
            {
                title: "Student Satisfaction",
                value: "40%",
                extra: "increase due to adaptive learning experience",
            },
        ],
    },
    features: [
        {
            id: 1,
            title: "Personalized Learning",
            sub_features: [
                "Adaptive learning paths",
                "Personalized content recommendations",
                "Individualized feedback and support"
            ]
        },
        {
            id: 2,
            title: "Automated Assessment",
            sub_features: [
                "Automated grading of assignments and quizzes",
                "Plagiarism detection",
                "Intelligent feedback on student work"
            ]
        },
    ],
    technologies: [
        { name: "Python", icon: <FaPython className="text-blue-500 text-3xl" /> },
        { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
        { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Techvelly built a high-quality website for my business and made every change I requested.",
            author: "Alonso Coronado",
            title: "Costa Rica"
        }
    ],
    faq: [
        {
            id: 1,
            question: "What kind of AI models do you use?",
            answer: "We use a variety of machine learning and deep learning models, including natural language processing (NLP) models for text analysis and computer vision models for image analysis."
        },
        {
            id: 2,
            question: "How do you ensure the ethical use of AI?",
            answer: "We follow a strict set of ethical guidelines for AI development and deployment. We also provide our clients with guidance on how to use AI responsibly."
        }
    ]
  },
  {
    id: 4,
    title: 'Custom eLearning',
    category: 'Web App Development',
    description: 'We develop bespoke eLearning solutions that are designed to meet your specific learning objectives. Our team of instructional designers and developers create engaging and interactive courses that are tailored to your content and your audience. We use the latest technologies and instructional design principles to create eLearning experiences that are both effective and memorable.',
    image: '/img/edutech/ELearn.jpg',
    sub_headers: {
        title: "Custom eLearning",
        sub_points: [
            "Bespoke eLearning solutions designed to meet your specific learning objectives.",
            "Engaging and interactive courses tailored to your content and audience.",
            "Effective and memorable eLearning experiences."
        ],
        mockupImage: "/img/edutech/ELearn.jpg",
    },
    problem: {
        challenges: [
            "Creating engaging and interactive content that holds the learner's attention.",
            "Ensuring the eLearning solution is accessible to all learners.",
            "Tracking learner progress and measuring the effectiveness of the training."
        ],
        mockupImage: "/img/edutech/ELearn.jpg",
    },
    solutions: {
        desc: "We create custom eLearning solutions that are designed to be engaging, interactive, and effective. Our team of instructional designers and developers work closely with you to create content that is tailored to your specific needs. We also ensure that our eLearning solutions are accessible to all learners and provide robust tracking and reporting features.",
        points: [
            "Engaging and interactive course content.",
            "Accessible design for all learners.",
            "Robust tracking and reporting features.",
            "Gamification and social learning features.",
            "Mobile-friendly and responsive design."
        ],
        mockupImage: "/img/edutech/ELearn.jpg",
    },
    process: [
        {
            id: 1,
            title: "Instructional Design & Content Strategy",
            description: "Our instructional designers work with you to develop a content strategy and create engaging and interactive learning activities."
        },
        {
            id: 2,
            title: "Visual Design & Storyboarding",
            description: "We create a visually appealing design and develop storyboards to outline the flow and structure of the eLearning course."
        },
        {
            id: 3,
            title: "SCORM-Compliant Development & Testing",
            description: "We develop the eLearning course using the latest authoring tools and ensure it is SCORM-compliant for easy integration with any LMS."
        },
        {
            id: 4,
            title: "Deployment & Learner Support",
            description: "We deploy the course to your LMS and provide ongoing support to your learners to ensure a smooth learning experience."
        }
    ],
    benefits: {
        desc: "Our custom eLearning solutions have helped clients improve employee performance, reduce training costs, and increase employee engagement through interactive and effective content.",
        metrics: [
            {
                title: "Knowledge Retention",
                value: "30%",
                extra: "improvement with interactive content",
            },
            {
                title: "Training Time",
                value: "50%",
                extra: "reduction with self-paced learning",
            },
            {
                title: "Employee Engagement",
                value: "40%",
                extra: "increase with gamification and social learning",
            },
        ],
    },
    features: [
        {
            id: 1,
            title: "Interactive Content",
            sub_features: [
                "Simulations and scenarios",
                "Quizzes and assessments",
                "Videos and animations"
            ]
        },
        {
            id: 2,
            title: "Learner Engagement",
            sub_features: [
                "Gamification and leaderboards",
                "Social learning and collaboration tools",
                "Personalized learning paths"
            ]
        },
    ],
    technologies: [
        { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
        { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
        { name: "HTML5", icon: <FaHtml5 className="text-orange-500 text-3xl" /> },
        { name: "PostgreSQL", icon: <FaJava className="text-blue-300 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "Working with Techvelly was an amazing experience. They went above and beyond, stayed in touch through every step, and handled all my requests with real care and professionalism.",
            author: "Leo Valmont",
            title: "Portugal"
        }
    ],
    faq: [
        {
            id: 1,
            question: "What authoring tools do you use?",
            answer: "We use a variety of authoring tools, including Articulate Storyline, Adobe Captivate, and our own custom-built tools."
        },
        {
            id: 2,
            question: "Can you create content in multiple languages?",
            answer: "Yes, we can create and translate content into multiple languages to meet the needs of your global workforce."
        }
    ]
  },
  {
    id: 5,
    title: 'Mobile Learning',
    category: 'Mobile App Development',
    description: 'Deliver learning anytime, anywhere with our Mobile Learning solutions. We design and develop responsive and intuitive mobile learning applications that allow your learners to access content on the go. Our mobile learning solutions are designed to provide a seamless experience across all devices, ensuring that your learners can access the content they need, whenever they need it.',
    image: '/img/edutech/MBL.jpg',
    sub_headers: {
        title: "Mobile Learning",
        sub_points: [
            "Deliver learning anytime, anywhere.",
            "Responsive and intuitive mobile learning applications.",
            "Seamless experience across all devices."
        ],
        mockupImage: "/img/edutech/MBL.jpg",
    },
    problem: {
        challenges: [
            "Designing a user-friendly interface for small screens.",
            "Ensuring the app works offline and syncs data when online.",
            "Optimizing performance for a wide range of mobile devices."
        ],
        mockupImage: "/img/edutech/MBL.jpg",
    },
    solutions: {
        desc: "We develop mobile learning apps that are designed for on-the-go learning. Our apps feature a user-friendly interface, offline access to content, and performance optimization for a wide range of devices. We also include features like push notifications and social learning to keep learners engaged.",
        points: [
            "User-friendly interface for small screens.",
            "Offline access to content.",
            "Performance optimization for a wide range of devices.",
            "Push notifications to remind learners.",
            "Social learning and collaboration features."
        ],
        mockupImage: "/img/edutech/MBL.jpg",
    },
    process: [
        {
            id: 1,
            title: "Mobile-First Strategy & UX Design",
            description: "We design a mobile-first user experience to ensure your learning content is easily accessible and engaging on any device."
        },
        {
            id: 2,
            title: "Cross-Platform App Development",
            description: "We develop a responsive and intuitive mobile learning app that provides a seamless experience across both iOS and Android devices."
        },
        {
            id: 3,
            title: "Offline Access & Performance Optimization",
            description: "We enable offline access to content and optimize app performance for a wide range of mobile devices and network conditions."
        },
        {
            id: 4,
            title: "App Store Deployment & Support",
            description: "We handle the entire app store submission process and provide ongoing support to ensure your app stays up-to-date."
        }
    ],
    benefits: {
        desc: "Our mobile learning solutions have helped clients reach a wider audience and provide a more flexible learning experience, increasing learner engagement and completion rates.",
        metrics: [
            {
                title: "Learner Accessibility",
                value: "90%",
                extra: "increase for on-the-go learners",
            },
            {
                title: "Completion Rates",
                value: "35%",
                extra: "increase with just-in-time learning",
            },
            {
                title: "Learner Engagement",
                value: "50%",
                extra: "increase with push notifications and social learning",
            },
        ],
    },
    features: [
        {
            id: 1,
            title: "On-the-Go Learning",
            sub_features: [
                "Access courses and content anytime, anywhere",
                "Download content for offline viewing",
                "Sync progress across devices"
            ]
        },
        {
            id: 2,
            title: "Mobile-First Design",
            sub_features: [
                "Intuitive and user-friendly interface",
                "Responsive design for all screen sizes",
                "Touch-friendly navigation and controls"
            ]
        },
    ],
    technologies: [
        { name: "React Native", icon: <FaReact className="text-blue-500 text-3xl" /> },
        { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
        { name: "JavaScript", icon: <FaJs className="text-yellow-400 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "I hired Techvelly after seeing their reviews, and they exceeded my expectations. Fast, professional, and great communication throughout — a pleasure to work with!",
            author: "Grace",
            title: "Canada"
        }
    ],
    faq: [
        {
            id: 1,
            question: "What platforms do you support?",
            answer: "We develop mobile learning apps for both iOS and Android devices."
        },
        {
            id: 2,
            question: "Can the app be customized to match our branding?",
            answer: "Yes, we can customize the app to match your company's branding and style guidelines."
        }
    ]
  },
  {
    id: 6,
    title: 'Microlearning',
    category: 'Web App Development',
    description: 'Our Microlearning solutions deliver bite-sized learning modules that are designed for maximum retention and engagement. We create short, focused learning nuggets that can be consumed in minutes, making it easy for your learners to fit learning into their busy schedules. Our microlearning solutions are perfect for just-in-time learning and performance support.',
    image: '/img/edutech/Microlearning-Blog-Header.png',
    sub_headers: {
        title: "Microlearning",
        sub_points: [
            "Bite-sized learning modules for maximum retention and engagement.",
            "Short, focused learning nuggets that can be consumed in minutes.",
            "Perfect for just-in-time learning and performance support."
        ],
        mockupImage: "/img/edutech/Microlearning-Blog-Header.png",
    },
    problem: {
        challenges: [
            "Creating concise and impactful learning content.",
            "Organizing content in a way that is easy to navigate and search.",
            "Delivering content in a variety of formats to keep learners engaged."
        ],
        mockupImage: "/img/edutech/Microlearning-Blog-Header.png",
    },
    solutions: {
        desc: "We create microlearning solutions that deliver short, focused learning nuggets in a variety of formats, including videos, infographics, and interactive quizzes. Our platform is designed to be easy to navigate and search, making it easy for learners to find the content they need, when they need it.",
        points: [
            "Concise and impactful learning content.",
            "Easy to navigate and search.",
            "Content delivered in a variety of formats.",
            "Mobile-friendly and responsive design.",
            "Tracking and reporting features."
        ],
        mockupImage: "/img/edutech/Microlearning-Blog-Header.png",
    },
    process: [
        {
            id: 1,
            title: "Content Curation & Nugget Creation",
            description: "We work with you to curate and create bite-sized learning nuggets that are focused, concise, and easy to consume."
        },
        {
            id: 2,
            title: "Multimedia & Interactive Content Design",
            description: "We design a variety of engaging content formats, including videos, infographics, and interactive quizzes, to keep learners engaged."
        },
        {
            id: 3,
            title: "Searchable Content Library Development",
            description: "We build a searchable content library that makes it easy for learners to find the information they need, when they need it."
        },
        {
            id: 4,
            title: "Mobile-First Deployment & Analytics",
            description: "We deploy the microlearning content on a mobile-first platform and provide detailed analytics on learner engagement and performance."
        }
    ],
    benefits: {
        desc: "Our microlearning solutions have helped clients improve knowledge retention, increase learner engagement, and provide just-in-time support to their employees.",
        metrics: [
            {
                title: "Knowledge Retention",
                value: "55%",
                extra: "improvement with bite-sized content",
            },
            {
                title: "Learner Engagement",
                value: "45%",
                extra: "increase with varied content formats",
            },
            {
                title: "Time to Competency",
                value: "35%",
                extra: "reduction with just-in-time learning",
            },
        ],
    },
    features: [
        {
            id: 1,
            title: "Bite-Sized Content",
            sub_features: [
                "Short videos and animations",
                "Infographics and interactive PDFs",
                "Quizzes and knowledge checks"
            ]
        },
        {
            id: 2,
            title: "Just-in-Time Learning",
            sub_features: [
                "Searchable content library",
                "Content recommendations",
                "Mobile access for on-the-go learning"
            ]
        },
    ],
    technologies: [
        { name: "React", icon: <FaReact className="text-blue-500 text-3xl" /> },
        { name: "JavaScript", icon: <FaJs className="text-yellow-400 text-3xl" /> },
        { name: "HTML5", icon: <FaHtml5 className="text-orange-500 text-3xl" /> },
        { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
        { name: "MongoDB", icon: <FaJava className="text-green-300 text-3xl" /> },
    ],
    testimonials: [
        {
            id: 1,
            quote: "It was a pleasure working with the Techvelly Team. They delivered exactly what I wanted — a professional design, clear communication, and great attention to detail.",
            author: "Barbara",
            title: "Usa"
        }
    ],
    faq: [
        {
            id: 1,
            question: "What is microlearning?",
            answer: "Microlearning is a way of teaching and delivering content to learners in small, very specific bursts. The learners are in control of what and when they're learning."
        },
        {
            id: 2,
            question: "What are the benefits of microlearning?",
            answer: "Microlearning is more engaging, less time-consuming, and leads to better knowledge retention than traditional training methods."
        }
    ]
  }
];